import { onUnmounted, shallowRef } from 'vue'

export function useMagicLinkSessionPoll(checkStatus, onAuthenticated, onOtpSent, intervalMs = 5000) {
  const isPolling = shallowRef(false)
  let timer = null
  let isChecking = false

  const clearTimer = () => {
    if (timer !== null) {
      window.clearTimeout(timer)
      timer = null
    }
  }

  const stop = () => {
    isPolling.value = false
    clearTimer()
  }

  const scheduleNextCheck = () => {
    clearTimer()
    timer = window.setTimeout(check, intervalMs)
  }

  const check = async () => {
    if (!isPolling.value || isChecking) return

    isChecking = true

    try {
      const { data } = await checkStatus()

      if (data.authenticated) {
        stop()
        onAuthenticated(data.redirect)
        return
      }

      if (typeof onOtpSent === 'function' && data.redirect) {
        stop()
        onOtpSent(data.redirect)
        return
      }
    } catch {
      // A transient status failure should not interrupt the sign-in wait screen.
    } finally {
      isChecking = false

      if (isPolling.value) {
        scheduleNextCheck()
      }
    }
  }

  const start = () => {
    if (isPolling.value) return

    isPolling.value = true
    void check()
  }

  onUnmounted(stop)

  return { isPolling, start, stop }
}
